import React from 'react';

export default (props) => (
  <svg {...props} width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" r="20" fill="#00DD9B" />
    <path d="M17.7082 25C17.5089 25 17.3096 24.9002 17.21 24.8005L13.2242 20.8105C12.9253 20.5112 12.9253 20.0125 13.2242 19.7132C13.5231 19.414 14.0214 19.414 14.3203 19.7132L17.7082 23.1047L25.6797 15.2244C25.9786 14.9252 26.4769 14.9252 26.7758 15.2244C27.0747 15.5237 27.0747 16.0224 26.7758 16.3217L18.306 24.8005C18.1068 24.9002 18.0071 25 17.7082 25Z" fill="white" />
  </svg>
);
